<!-- ==================== TOP BANNER ==================== -->
<div class="app-top-banner">
    <!-- Personalized welcome message -->
    <div class="banner-left">
        <span>{{ 'LAYOUT.BANNER.TITLE' | translate: { name: userName() } }}</span>
    </div>

    <div class="banner-right">
        <!-- Currency selector -->
        <!-- <app-dropdown
            [options]="currencyOptions()"
            [selected]="currentCurrencyOption() ?? null"
            [trackBy]="trackByCurrencyCode"
            (selectedChange)="onCurrencySelected($event)"
            class="banner-dropdown-instance"
        >
            <ng-template #trigger let-current>
                <i class="pi pi-dollar"></i>
                <span>{{ current?.currencyCode }}</span>
            </ng-template>
            <ng-template #option let-currency>
                <span>{{ currency.label }}</span>
            </ng-template>
        </app-dropdown> -->

        <!-- Language selector -->
        <app-dropdown
            [options]="languageOptions()"
            [selected]="currentLanguageOption() ?? null"
            [trackBy]="trackByLanguageCode"
            (selectedChange)="onLanguageSelected($event)"
            class="banner-dropdown-instance"
        >
            <ng-template #trigger let-current>
                <i class="pi pi-globe"></i>
                <span>{{ current?.languageCode | uppercase }}</span>
            </ng-template>
            <ng-template #option let-language>
                <span>{{ language.label }}</span>
            </ng-template>
        </app-dropdown>

        <!-- Logout, public users only -->
        @if (authUserState().loginType === 'public') {
        <button type="button" class="banner-logout-btn" (click)="logout()">
            <i class="pi pi-sign-out"></i>
            <span>{{ 'LAYOUT.BANNER.LOGOUT' | translate }}</span>
        </button>
        }
    </div>
</div>
